exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redeem-mode-dialog{background:#f5f7fa;max-width:100%;max-height:60%}.redeem-mode-toggle-container{display:inline-block;margin-top:2rem;cursor:pointer}.redeem-mode-toggle-container h6{display:inline-block;margin:0 3.5rem .25rem 0}.redeem-mode-toggle-container #orders-group-redeem-toggle{vertical-align:middle}.redeem-mode-toggle-container span{margin-left:.5rem}.redeem-mode-toggle-info{font-size:.75rem;color:var(--text-light)}", ""]);

// exports
